import "./styles/Hero.css";

const Hero = () => {
  return (
    <div className="about-hero-wrapper">
      <div className="about-hero">
        <h1>品牌特色</h1>
        <p>
          特色重點特色重點特色重點特色重點特色重點特色重點特色重點特色重點特色重點特色重點特色重點
        </p>
      </div>
    </div>
  );
};

export default Hero;
